import { FieldErrors } from 'react-hook-form';

/**
 * Checks if the save button should be disabled based on form errors.
 *
 * @param {FieldErrors} errors - An object representing the current form errors.
 * Each key represents a form field, and the value is the error message or
 * validation error for that field.
 *
 * @returns {boolean} - Returns `true` if there are any errors, meaning the save button should be disabled;
 * otherwise, returns `false`.
 */
export const isSaveDisabled = (errors: FieldErrors): boolean => {
  return Object.values(errors).some((error) => error);
};
